<template lang="pug">
  el-form(ref="form" @submit.native.prevent='' label-position="top" :rules="rules" :model="course")

    el-row(:gutter="40")
      el-col(:lg="17")
        el-form-item(prop="title")
          Label(slot="label" label="Title")
            | Insert course title here, this will be seen by the colleagues
            br
            | who have been assigned to this course.

          el-input(v-model.trim="course.title" size='large')

        el-form-item(prop="description")
          Label(slot="label" label="Description")
            | Add a helpful description that briefly explains the content within this course.

          el-input(type='textarea' :autosize="{ minRows: 3, maxRows: 10}" v-model.trim="course.description")

        el-form-item(prop="image")
          Label(slot="label" label="Cover image")
            | Add a cover image which illustrates the content within this course.

          ImageField(v-model='course.coverImagePath' :initial-url='course.coverImageUrl' bucket-key='courses')

        el-form-item(prop="keywords")
          Label(slot="label" label="Add keywords for search")
            | Tag this course with additional text to help users find the course when searching.

          el-select(v-model='course.keywords' multiple='' filterable='' allow-create='')
            el-option(v-for='item in course.keywords' :key='item' :label='item' :value='item')

        el-form-item(prop="type")
          Label(slot="label" label="Course type")
            p Select your course type from the menu
            p SCORM - Standardised e-learning format - required for course tracking, colleague performance and reporting. Get in contact with us if you would like to speak to us about creating SCORM content for you.
            p Other Content (e.g. PDF/Power Point) - note that this does not track assessment scores
            p URL - note that this does not track assessment scores

          el-select(v-model='course.type')
            el-option(v-for='opt in courseTypeOptions' :key='opt.value' :value='opt.value' :label='opt.label') {{ opt.label }}

        el-form-item(label="Upload course content" prop="archiveFilePath")
          FileField(v-if="course.type === 'scorm'" v-model='course.archiveFilePath' :initial-url='course.archiveFileUrl' bucket-key='scorm-courses' accept='application/zip' @upload-started='uploadInProgress = true' @upload-success='uploadInProgress = false')
            .file-placeholder(slot="placeholder")
              icon.scorm-icon(name='file-archive' color='#1D8CE0' :scale='3')
              .scorm-copy Upload a SCORM Zip file

          FileField(v-if="course.type === 'custom'" v-model='course.customFilePath' :initial-url='course.customFileUrl' bucket-key='course-custom-files' accept='*' @upload-started='uploadInProgress = true' @upload-success='uploadInProgress = false')
            .file-placeholder(slot="placeholder")
              icon.scorm-icon(name='file' color='#1D8CE0' :scale='3')
              .scorm-copy Upload a custom file

      el-col(:lg="7")
        FormSidebar
          template(slot="header")
            .schedule-status-label Status:
            el-switch(:width="100" v-model="published" on-text="Published" off-text="Draft" on-color="#7fc4be" off-color="#dd6e69")

          template(slot="content")
            el-form-item
              template(slot="Notify users")
                | Add keywords for search
                el-tooltip(placement="top")
                  fa-icon.tooltip-icon-p(icon="info-circle" size="xs")
                  template(slot="content")
                    p Notify colleagues of outstanding courses that they are yet to take or that require retakes.
                    p Filter users by groups and programme/course pass/fail/incomplete status.
                    p Reset a colleagues results at course level to allow retakes.

              el-checkbox(v-model='course.notifySms')
                | By SMS
                el-tooltip(placement="top")
                  fa-icon.tooltip-icon-p(icon="info-circle" size="xs")
                  template(slot="content")
                    | This will only send to users that we have a valid mobile number stored for

              el-checkbox(v-model='course.notifyEmail') By email

          template(slot="actions")
            el-button(v-if='!published' type='primary' native-type='submit' size='large' @click="onSave" :disabled='uploadInProgress')
              template(v-if='uploadInProgress') Course uploading, please wait...
              template(v-else) Save as Draft

            el-button(v-if='published' type='primary' native-type='submit' size='large' @click="onSave" :disabled='uploadInProgress')
              template(v-if='uploadInProgress') Course uploading, please wait...
              template(v-else) Save

            el-button(v-if='!published' type='success' native-type='submit' size='large' @click="onPublish" :disabled='uploadInProgress')
              template(v-if='uploadInProgress') Course uploading, please wait...
              template(v-else) Publish

            el-button(v-if='showDelete' type='text' @click="onDelete") Delete

</template>

<script>
import AssigneePicker from "@/brapp/components/shared/AssigneePicker";
import FormSidebar from "@/shared/components/layout/FormSidebar";
import ImageField from "@/shared/components/ImageField";
import FileField from "@/shared/components/FileField";
import LabelWithHelp from "@/itrain/components/shared/LabelWithHelp";

export default {
  components: {
    AssigneePicker,
    FormSidebar,
    ImageField,
    FileField,
    Label: LabelWithHelp
  },
  model: {
    prop: "course",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    course: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formSubmitted: false,
      uploadInProgress: false,
      content: [],
      rules: {
        title: [{ required: true, message: "Required field", trigger: "blur" }]
      },
      courseTypeOptions: [
        { value: "scorm", label: "SCORM" },
        { value: "custom", label: "Custom" }
      ]
    };
  },
  computed: {
    published: {
      get() {
        return this.course.status === "published";
      },
      set(val) {
        this.course.status = val ? "published" : "draft";
      }
    }
  },
  methods: {
    onSave() {
      this.formSubmitted = true;
      this.$refs.form.validate(valid => {
        this.$emit("save", { valid });
      });
    },
    onPublish() {
      this.course.status = "published";
      this.onSave();
    },
    onDelete() {
      this.$emit("delete");
    }
  }
};
</script>

<style scoped lang="scss">
.scorm-icon {
  margin-right: 20px;
}
:global(.el-checkbox) {
  margin-right: 10px;
}
</style>
